import React from "react";
import ReactDOM from "react-dom";

import withRouter from '../libs/withRouter.jsx';
import withAuth from "../libs/withAuth.jsx";

import { Icon } from "monday-ui-react-core";
import { CloseSmall } from "monday-ui-react-core/dist/allIcons";

import mondaySdk from "monday-sdk-js";
const monday = mondaySdk();
monday.setApiVersion(config.monday_api.version);

class Notification extends React.Component
{
    constructor(props)
    {
        super(props);
        
        this.user = this.props.auth.user;
        
        this.state = {
            is_show: false,
            user: this.user,
        };
        
        this.loader = React.createRef();
    }
    
    async loadData()
    {
        var this_component = this;
        
        if(this_component.props.id!=false)
        {
            var res = await monday.storage.instance.getItem('Notification_'+this_component.state.user.id+'_'+this_component.props.id);
            //console.log(res);
            var is_show = (res.data.value==='1')?false:true;
            this_component.setState( {'is_show': is_show} );
        }
        else
        {
            this_component.setState( {'is_show': true} );
        }
    }
    
    async componentDidMount()
    {
        var this_component = this;
        
        await this_component.loadData();
    }
    
    async hide(event)
    {
        var this_component = this;
        
        event.preventDefault();
        event.stopPropagation();
        
        monday.execute("confirm", {
            message: "Confirm that you want to close this Notification",
            confirmButton: "Close", 
            cancelButton: "Cancel", 
            excludeCancelButton: false
        }).then( async(res) => {

            //console.log('Confirm dialog',res.data);

            if(res.data.confirm == true)
            {
        
                var res = await monday.storage.instance.setItem('Notification_'+this_component.state.user.id+'_'+this_component.props.id, '1');

                await this_component.loadData();
            }
        });
    }
    
    
    render()
    {
        var this_component = this;
        
        return (
            <>
            {
            (this_component.state.is_show===true)?
                (
                <div className={"alert alert-primary mt-2" + (this_component.props.bold?' textBold':'')} role="alert" style={{ 'color':'var(--primary-text-color)', 'backgroundColor': this_component.props.backgroundColor, 'display': 'flex' }}>
                    <div style={{ 'flexGrow':1 }}>
                        {this_component.props.children}
                    </div>
                    {
                    (this_component.props.id!==false)?
                        <div><Icon clickable iconSize="20" icon={CloseSmall} onClick={(e) => this_component.hide(e)} /></div>
                        :
                        null
                    }
                </div>
                )
                :
                null
            }
            </>
        );
    }
}

Notification.defaultProps = {
    'id': false,
    'backgroundColor': 'var(--warning-color-selected)',
    'bold': false
};

export default withRouter(withAuth(Notification));
